// Animació global per als canvis d'informació de la plantilla: què entra,
// què surt i què canvia de valor (preus, totals...). Un sol MutationObserver
// a <body>, activat des de Menu.jsx (present a totes les pàgines), així no
// cal tocar cada component ni res de la seva lògica: només s'afegeixen
// classes que CSS (global.css, "Canvis d'informació") anima amb el color
// corporatiu.
//
// - ENTRA: element nou de la llista → entra amb un anell de color.
// - SALE: element retirat de la llista → se'n deixa una còpia inerta que
//   s'encongeix i s'esvaeix (React ja l'ha tret del DOM, així no cal esperar).
// - VALOR: el text canvia (preu, total, comptador) → ressaltat de color.
//
// Res s'anima amb "reduir moviment" activat. Les files dels extres
// (.bh-cart__extra) tenen la seva pròpia lògica (avisoExtras.js).

const ENTRA = ".bh-habitacion, .bh-cart__item, .bh-cart__hab, .bh-tarifa, .bh-reserva-aviso, .bh-reserva-resultados, .bh-extra-hab";
const VALOR = ".pricebase, .totalprice, .prepago, #extracat, .bh-tarifa__precio, .bh-reserva-total strong";
// El desplegable d'hostes/habitacions del cercador queda fora: hi ha
// botons +/− que es premen seguit i l'animació hi feia moure la llista.
const IGNORAR = "[data-sin-animar], .bh-cambio-sale, .formpersonas";

const esElemento = (n) => n.nodeType === 1;

const iniciarAnimarCambios = () => {
    if (typeof window === "undefined" || !window.MutationObserver) return () => { };
    const reducido = window.matchMedia("(prefers-reduced-motion: reduce)");
    if (reducido.matches) return () => { };

    const ultimoTexto = new WeakMap();

    const reiniciar = (el, clase) => {
        el.classList.remove(clase);
        void el.offsetWidth;
        el.classList.add(clase);
        el.addEventListener("animationend", () => el.classList.remove(clase), { once: true });
    };

    const fantasma = (nodo, padre, siguiente) => {
        const copia = nodo.cloneNode(true);
        // Còpia inerta: sense controls (els formularis els busquen per nom/id)
        copia.querySelectorAll("input, select, textarea, button").forEach((c) => c.remove());
        copia.querySelectorAll("[id]").forEach((c) => c.removeAttribute("id"));
        copia.removeAttribute("id");
        copia.setAttribute("aria-hidden", "true");
        copia.setAttribute("inert", "");
        copia.classList.add("bh-cambio-sale");
        padre.insertBefore(copia, siguiente && siguiente.parentNode === padre ? siguiente : null);
        copia.style.setProperty("--bh-alto", copia.offsetHeight + "px");
        copia.addEventListener("animationend", () => copia.remove(), { once: true });
        setTimeout(() => copia.remove(), 1500); // xarxa de seguretat
    };

    const observador = new MutationObserver((mutaciones) => {
        mutaciones.forEach((m) => {
            if (m.target.nodeType === 1 && m.target.closest && m.target.closest(IGNORAR)) return;

            // Valors que canvien de text
            const base = m.target.nodeType === 1 ? m.target : m.target.parentElement;
            const valor = base && base.closest ? base.closest(VALOR) : null;
            if (valor && !valor.closest(IGNORAR)) {
                const ara = valor.textContent.trim();
                const abans = ultimoTexto.get(valor);
                ultimoTexto.set(valor, ara);
                if (abans !== undefined && abans !== ara) reiniciar(valor, "bh-cambio-valor");
            }

            m.addedNodes.forEach((n) => {
                if (!esElemento(n) || n.matches(IGNORAR)) return;
                if (n.matches(ENTRA)) reiniciar(n, "bh-cambio-entra");
                n.querySelectorAll && n.querySelectorAll(VALOR).forEach((v) => ultimoTexto.set(v, v.textContent.trim()));
            });

            m.removedNodes.forEach((n) => {
                if (!esElemento(n) || n.matches(IGNORAR) || !n.matches(ENTRA)) return;
                if (!m.target.isConnected) return;
                fantasma(n, m.target, m.nextSibling);
            });
        });
    });

    document.querySelectorAll(VALOR).forEach((v) => ultimoTexto.set(v, v.textContent.trim()));
    observador.observe(document.body, { childList: true, characterData: true, subtree: true });

    return () => observador.disconnect();
};

export default iniciarAnimarCambios;
